// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__23rpk","inputWrap":"Table_inputWrap__2F7oj","col":"Table_col__3wDYW","bmiTooltip":"Table_bmiTooltip__3FcHU"};